export const SkillMappingType = {
    INDUSTRY_ROLE: 'INDUSTRY_ROLE' ,
    ADD_SKILL: 'ADD_SKILL',
    SKILL_MATCH: 'SKILL_MATCH',
    INFERRED_SKILL: 'INFERRED_SKILL',
}